import { ValidationError } from '@cian/peperrors/shared';

import { Dispatch, IAppState } from '../../../shared/common/state';
import { ResponseError } from '../../../shared/errors';
import { transformFlatTourBookingSchedule } from '../../../shared/mappers/transformFlatTourBookingSchedule';
import {
  fetchGetFlatTourBookingSchedule,
  TGetFlatTourBookingScheduleResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/get-flat-tour-booking-schedule';
import { canMakeFlatViewOrder } from '../../../shared/selectors/newbuildingFlatTourBooking';
import { getNewbuildingId } from '../../../shared/selectors/newbuildingHeader';
import { setScheduleData } from '../../../shared/serp/state/flatTourBooking';
import { isValidFlatTourBookingSchedule } from '../../../shared/utils/flatTourBooking';

export function getFlatTourSchedule() {
  return async (dispatch: Dispatch, getState: () => IAppState): Promise<void> => {
    const { logger, httpApi } = getState();

    try {
      const isTourEnabled = canMakeFlatViewOrder(getState());
      const newbuildingId = getNewbuildingId(getState());

      if (!isTourEnabled) {
        return;
      }

      const response: TGetFlatTourBookingScheduleResponse = await fetchGetFlatTourBookingSchedule({
        httpApi,
        parameters: { newbuildingId: newbuildingId ?? 0 },
      });

      if (response.statusCode !== 200) {
        throw new ResponseError({
          domain: 'getFlatTourSchedule',
          message: 'Не удалось получить расписание бронирований',
        });
      }

      if (!isValidFlatTourBookingSchedule(response.response.schedule)) {
        throw new ValidationError({
          domain: 'getFlatTourSchedule',
          message: 'Ошибка валидации ISchedule в getFlatTourSchedule',
        });
      }

      const schedule = transformFlatTourBookingSchedule(response.response.schedule);

      dispatch(setScheduleData(schedule));
    } catch (error) {
      logger.error(error, {
        domain: 'getFlatTourSchedule',
      });
    }
  };
}
